/* global axios */

import ApiClient from './ApiClient';

export const buildAuditLogsParams = (page, search) => {
  let params = `page=${page}`;

  if (search) {
    params = `${params}&q=${search}`;
  }

  return params;
};

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page, search = '' } = {}) {
    const url = page
      ? `${this.url}?${buildAuditLogsParams(page, search)}`
      : this.url;
    return axios.get(url);
  }

  search(search = '', page = 1) {
    const requestURL = `${this.url}/search?${buildAuditLogsParams(
      page,
      search
    )}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, queryPayload) {
    const url = `${this.url}/filter?page=${page}`;
    return axios.post(url, queryPayload);
  }

  download(queryPayload = null) {
    const url = `${this.url}/download`;
    return axios.post(url, queryPayload, { responseType: 'blob' });
  }
}

export default new AuditLogs();
